import React, { useEffect, useRef, useState } from "react";
import { useOthersStore } from "../../store/othersStore.js";
import { Link } from "react-router-dom";
import { Table, ConfigProvider, Input, Popconfirm } from "antd";

import { VioletButtonLarge } from "../../components/button";


import images from "../../assets";

export default function Category() {
  const { categories, isCategoryLoading, getCategories, deleteCategory } =
    useOthersStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (categories.length === 0) {
      fetchCategories();
    } else {
      applyFilters();
    }
  }, [categories, searchText]);

  const fetchCategories = async () => {
    getCategories({});
  };

  const applyFilters = () => {
    let filtered = categories;

    if (searchText) {
      filtered = filtered?.filter((item) =>
        item?.name?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleDelete = (id) => {
    const payload = { id: id };
    deleteCategory(payload, () => {
      fetchCategories();
    });
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "ID",
      width: 70,
      render: (text, record) => record?.id,
      key: "1",
    },
    {
      title: "Slug",
      width: 80,

      render: (text, record) => record?.slug,
      key: "2",
    },
    {
      title: "Name",
      key: "3",
      width: 150,
      render: (text, record) => record?.name,
      fixed: "left",
    },
    {
      title: "Description",
      key: "11",
      width: 200,
      render: (text, record) => record?.description,
      fixed: "left",
    },

    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          <Link to={`/category/${record?.id}`}>
            <img src={images.editIcon} alt="" />
          </Link>
          <Popconfirm
            title="Delete category?"
            description="Are you sure you want to delete this category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <img src={images.deleteIcon} alt="" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="blog"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <Link to={"/addCategory"} className="w-max">
          <VioletButtonLarge text="Add Category" />
        </Link>
      </div>
      <div>
        Total categories: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isCategoryLoading}
          rowKey={(record) => record?.id}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}








